import { Component, Inject } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { Router, NavigationCancel, NavigationEnd, ActivatedRoute } from '@angular/router';
import { Location, LocationStrategy, PathLocationStrategy } from '@angular/common';
//import { filter } from 'rxjs/operators';
import { filter } from 'rxjs/operators';
declare let $: any;
import { TranslateService } from '@ngx-translate/core';
import { environment as env } from '../environments/environment'
import { BehaviorSubject } from 'rxjs';

//declare const gtag: Function; // <------------Important: the declartion for gtag is required!
declare let dataLayer: any[];
//let win = <any>window;
//var _hsq = (win._hsq = win._hsq || []);// <------------Important: the declartion for Hubspot is required!

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    providers: [
        Location, {
            provide: LocationStrategy,
            useClass: PathLocationStrategy
        }
    ]
})
export class AppComponent {
    location: any;
    routerSubscription: any;
    flag_app :any;

    excludedUrls = [
        '/dashboard',
        '/dashboard-profile',
        '/dashboard-operative',
        '/dashboard-environment',
        '/dashboard-monitoring',
        '/dashboard-comercial',
        '/dashboard-project-detail',
        '/dashboard-asset-map',
        '/dashboard-target-net-zero',
        '/dashboard-download',
        '/quotation-scotiabank',
        '/quotation-scotiabank/step2',
        '/quotation-scotiabank/step3',
        '/quotation-libertad',
        '/quotation-libertad/step2',
        '/quotation-libertad/step3',
        '/quotation-clubcampestre',
        '/quotation-clubcampestre/step2',
        '/quotation-clubcampestre/step3',
        '/quotation-marykay',
        '/quotation-marykay/step2',
        '/quotation-marykay/step3',
        '/quotation-buenfin',
        '/quotation-buenfin/step2',
        '/quotation-buenfin/step3',
        '/quotation-asturiano',
        '/quotation-asturiano/step2',
        '/quotation-asturiano/step3',
        '/quotation-dhl',
        '/quotation-dhl/step2',
        '/quotation-dhl/step3',
        '/quotation-mvs',
        '/quotation-mvs/step2',
        '/quotation-mvs/step3',
        '/quotation-bh',
        '/quotation-bh/step2',
        '/quotation-bh/step3',
        '/quotation-heb',
        '/quotation-heb/step2',
        '/quotation-heb/step3',
        '/quotation-rica',
        '/quotation-rica/step2',
        '/quotation-rica/step3',
        '/quotation-rica#formRegister',
        '/asturiano',
        '/app-asturiano',
        '/quotation-asturiano?fromQuote=true',
        '/login',
        '/quotation',
        '/quotation/step2',
        '/quotation/step3',
        '/terms-conditions',
        '/terms-conditions?lang=en',
        '/privacy-policy',
        '/privacy-policy?lang=en',
        '/about',
        '/about?lang=en',
        '/dashboard-asset-map-inst',
        '/dashboard-project-detail-inst',
        '/init_installer',
        '/dashboard-profile-inst',
    ];

    showHeaderFooter: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

    shouldShowHeaderAndFooter(): boolean {
        // // return !this.excludedUrls.includes(this.router.url) && this.flag_app !== true;

        // // Verifica si la URL está en el array excludedUrls o si es una ruta no encontrada
        // const isExcludedUrl = this.excludedUrls.includes(this.router.url);
        // const isNotFound = this.router.config.some(route => route.path === '**' && this.router.url === this.router.serializeUrl(this.router.createUrlTree([this.router.url])));

        // // Devuelve false si la URL está en excludedUrls o es una ruta NotFound
        // return !(isExcludedUrl || isNotFound) && this.flag_app !== true;
        return false;
    }

    constructor(@Inject(DOCUMENT) private document: Document,public router: Router, private actroute :ActivatedRoute, public translate: TranslateService) {
        let machineId = localStorage.getItem('MachineId');
        if (!machineId) {
            // console.log("generate machineId="+machineId);
            machineId = crypto.randomUUID();
            localStorage.setItem('MachineId', machineId);
        }
        (this.document as any).intercom_user_id = machineId;

        translate.addLangs(env.array_lenguage);
        translate.setDefaultLang(env.language_default);
        translate.use(env.language_default);

                /*
                this.router.events
                    .pipe(filter((evt: any) => evt instanceof RoutesRecognized), pairwise())
                    .subscribe((events: RoutesRecognized[]) => {
                    console.log('previous url', events[0].urlAfterRedirects);
                    console.log('current url', events[1].urlAfterRedirects);
                });
                */

                /** START : Code to Track Page View using gtag.js and Hubspot */
                this.router.events
                .pipe(filter((e): e is NavigationEnd => e instanceof NavigationEnd))
                    .subscribe((event: NavigationEnd) => {
                        //console.log("gtag googleAnalyticsId=" + env.googleAnalyticsId + " event page_view page_path="+event.urlAfterRedirects);
                        /*
                        gtag('config', env.googleAnalyticsId, {
                            page_path: event.urlAfterRedirects
                        });
                        */
                       /*
                        console.log('tracking pageview event.url='+event.url);
                        console.log('tracking pageview event.urlAfterRedirects='+event.urlAfterRedirects);
                        dataLayer.push({
                            event: 'pageview',
                            page: {
                              path: event.urlAfterRedirects
                              //,title: 'Your custom title'
                            }
                          });
                        */
                        //console.log('tracking pageview event.url='+event.url);
                        //console.log('tracking pageview this.location='+this.location);

                        let urlPre;
                        if(this.location){
                            let aux = this.location.substring(1);
                            urlPre = env.url + aux;
                        }

                        let urlPost;
                        let urlTitle = 'home';
                        if(event.url){
                            let aux = event.url.substring(1);
                            urlPost = env.url + aux;

                            if (event.url != '/'){
                                urlTitle = event.url.substring(1)
                            }
                        }

                        // console.log('tracking pageview page_location='+urlPost);
                        // console.log('tracking pageview page_path='+event.url);
                        // console.log('tracking pageview page_referrer='+urlPre);
                        // console.log('tracking pageview page_title='+urlTitle);

                        dataLayer.push({
                            event: 'page_view',
                            //pageName: event.url,
                            eventModel: {
                                page_location: urlPost,
                                page_path: event.url,
                                page_referrer: urlPre,
                                page_title: urlTitle,
                              },
                        });

                        /*
                        dataLayer.push({
                            event: 'content-view',
                            pageName: event.url
                        });
                        */

                        // console.log('tracking end');
                        /*
                        if (_hsq != undefined) {
                            //console.log('tracking hubspot page view event.url='+event.url);
                            _hsq.push(['setPath', event.url]);
                            _hsq.push(['trackPageView']);
                            //console.log('tracking hubspot page view end');
                        }
                        */
                    });
    }

    ngOnInit(){
        this.recallJsFuntions();
        this.actroute.fragment.subscribe((fragment: any) => {
            if(fragment=='app')
            {
                this.flag_app =true;
            }

        })
    }

    private updateVisibility() {
        const shouldShow = this.shouldShowHeaderAndFooter();
        this.showHeaderFooter.next(shouldShow);
    }

    recallJsFuntions() {
        this.routerSubscription = this.router.events
        .pipe(filter(event => event instanceof NavigationEnd || event instanceof NavigationCancel))
        .subscribe(event => {
            this.location = this.router.url;
            this.updateVisibility();
            if (!(event instanceof NavigationEnd)) {
                return;
            }
            window.scrollTo(0, 0);
        });
    }

}
